import type { ReactNode } from 'react';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
    id: string;
    title: ReactNode;
    lead?: ReactNode;
    action?: ReactNode;
}

export default function SectionHeader({ id, title, lead, action }: SectionHeaderProps) {
    return (
        <header className={styles.header}>
            <h2 id={id} className={styles.title}>{title}</h2>
            {(lead || action) && (
                <div className={styles.aside}>
                    {lead && <p className={styles.lead}>{lead}</p>}
                    {action}
                </div>
            )}
        </header>
    );
}
